/*
 * @Author: edvardchen
 * @Date:   2016-11-16 19:54:15
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2018-09-17 18:00:29
 */

import React from 'react';
import autobind from 'core-decorators/lib/autobind';
import PropTypes from 'prop-types';
export default class QBLink extends React.Component {
  static propTypes = {
    url: PropTypes.string,
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    className: PropTypes.string,
    type: PropTypes.string,
  };

  @autobind
  onClick(event) {
    // remove color(rgb(159, 159, 159)) added by Safari
    this.el.style.color = null;

    const { onClick, url } = this.props;
    if (onClick && onClick(event, this.props) === false) {
      return;
    }
    if (url) {
      if (browser && browser.coolread) {
        browser.coolread.openExternalPage(url);
      } else {
        window.location.href = url;
      }
    }
  }

  render() {
    const { url, text, className, type } = this.props;
    return (
      <a
        href={url || 'javascript:'}
        className={className}
        onClick={this.onClick}
        ref={(node) => {
          this.el = node;
        }}
        type={type || 'a'}
      >
        {text}
      </a>
    );
  }
}
